<!--  -->
<template>
  <div class="container">
    <div class="item one">
      <div class="hint-one">企业名称</div>
      <input type="text" class="name f_14" v-model="companyName" placeholder="请输入企业名称" />
    </div>
    <div class="item">
      <div class="hint-one">统一社会信用代码</div>
      <input type="text" class="name f_14" v-model="companyCode" placeholder="请输入代码" />
    </div>
    <div class="item">
      <div class="hint-one">邮箱地址</div>
      <input type="text" class="name f_14" v-model="companyEmail" placeholder="请输入邮箱地址" />
    </div>
    <div class="item one">
      <div class="hint-one">设置密码</div>
      <input type="password" class="name f_14" v-model="firstPwd" placeholder="请输入密码" />
    </div>
    <div class="item">
      <div class="hint-one">确认密码</div>
      <input type="password" class="name f_14" v-model="secondPwd" placeholder="请确认密码" />
    </div>
    <div class="item one">
      <div class="hint-one">上传营业执照(请保持照片清晰、完整)</div>
      <div class="camera">
        <van-uploader :after-read="afterRead" :max-count="1" v-model="fileList" multiple />
      </div>
    </div>
    <button class="apply_register" @click="submit">申请注册</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Base64 } from "js-base64"; //base64加密

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      companyName: "", //公司名称
      companyCode: "", //统一社会信用代码
      companyEmail: "", //邮箱地址
      firstPwd: "", //第一次输入密码
      secondPwd: "", //第二次输入密码

      fileList: [
        // { url: '' },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        // { url: 'https://cloud-image', isImage: true }
      ],//显示的图片
      img:"",//base64图片路径
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    submit() {
      this.$http
        .companyRegister({
          company_name: this.companyName,
          company_code: this.companyCode,
          email: this.companyEmail,
          password: Base64.encode(this.firstPwd),
          password_again: Base64.encode(this.secondPwd),
          business_license: this.img
        })
        .then(res => {
          if(res.status == 1){
            this.$hide.alert({
              title:"提示",
              message:res.msg
            }).then(()=>{
              this.$router.push({path:"/submitSuccess"})
            })
          }else{
            this.$hide.alert({
              title:"提示",
              message:res.msg
            })
          }
        });
      // this.$router.push({path:"/submitSuccess"})
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.img = file.content
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  position: relative;
  .one {
    margin-top: 10px;
  }
  .item {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #dddddd;
    padding: 10px 18px 5px;
    box-sizing: border-box;
    line-height: 25px;
    .hint-one {
      color: #666666;
      width: 100%;
      font-size: 15px;
      margin: 0;
      padding: 0;
    }
    .name {
      border: none;
      height: 25px;
      display: inline-block;
      color: #333333;
      font-size: 17px;
      width: 100%;
      margin: 0;
      padding: 0;
    }

    input::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #333333;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #333333;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #333333;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #333333;
    }
    input::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #333333;
    }
    .camera {
      // width: 76px;
      height: 76px;
      background-color: #ffffff;
      position: relative;
      margin-bottom: 10px;
      margin-top: 10px;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 35px;
        height: 35px;
      }
    }
  }
  .apply_register {
    width: 90%;
    height: 44px;
    background-color: #2f85ed;
    border-radius: 22px;
    font-size: 18px;
    color: #fff;
    border: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }
}
</style>